export const getStyles = () => ({
  withStoreLoadingContainer: {
    minHeight: 84,
    '& .loading': {
      paddingTop: 30,
    },
  },
  withStoreErrorContainer: {
    paddingTop: 10,
    '& .alert': {
      alignItems: 'center',
      padding: [4, 16, 4, 12],

      '& .alert-image:before': {
        lineHeight: '32px',
      },

      '& .alert__content': {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center',
      },

      '& .alert__action': {
        marginLeft: 'auto',
        marginTop: 'unset',
      },
    },
    UrlContainer: {
      width: '435px',
      '& .store-url-text-container': {
        marginBottom: '10px',
      },
    },
    MobileUrlContainer: {
      width: '435px',
      marginTop: '20px',
    },
  },
});

